import { computed }      from 'mobx';
import type {ReactNode} from 'react';
import FileModel         from './globals/FileModel';
import { getShortLabel } from '../constants/Languages';

export default class StandMediaModel extends FileModel {
  static get path() {
    return '/backend/stand_media/{?id}';
  }

  save(options: any = {}): Promise<this> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();

      Object.keys(this.attributes).forEach(key => {
        formData.set(key, this.attributes[key]);
      });

      return this.connector
        .save(this, { ...options, patchAttributes: formData })
        .then(result => {
          this.onSaveSuccess(result, options);
          resolve(this);
        })
        .catch(err => reject(err));
    });
  }

  @computed
  get mediaFileName(): string {
    return this.get('mediaFileName');
  }

  @computed
  get objectUrl(): string {
    return this.get('objectUrl');
  }

  @computed
  get language(): string {
    return this.get('language');
  }

  @computed
  get languageShortLabel(): ReactNode {
    return getShortLabel(this.get('language'));
  }
}
